<button mat-stroked-button class="ca-button ca-button-xs block mx-auto" (click)="openDrawer()">
    <ca-icon class="ca-icon-s-16-p-0-f-16" icon="big-plus"></ca-icon>
    <span>{{ 'RBR.ROOM_LIST.ADD_ROOMS' | translate }}</span>
</button>

<ca-drawer #drawer overriddenWidth="664px">
    <h4 drawer-header class="ca-headline-4 ca-bold m-0">{{ 'RBR.ROOM_LIST.ADD_ROOMS' | translate }}</h4>
    <div drawer-body class="mt-4">
        <div class="flex gap-6">
            <ca-search-box
                placeholder="{{ 'RBR.ROOM_LIST.SEARCH_ROOM_TYPES' | translate }}"
                width="100%"
                class="grow"
                [(value)]="searchTerm"
                (clear)="search()"
            ></ca-search-box>
            <button mat-stroked-button class="ca-button ca-button-s" (click)="search()">
                <span>{{ 'CA.BUTTON.APPLY' | translate }}</span>
            </button>
        </div>
        <div class="mt-4 flex flex-col gap-3">
            @for (roomType of roomTypes; track roomType) {
                <div class="room-type-stepper-row">
                    <ca-numeric-stepper
                        [value]="roomCounts()[roomType] ?? 0"
                        (valueChange)="changeRoomCount(roomType, $event)"
                    ></ca-numeric-stepper>
                    <span class="room-type-stepper-label">{{ roomType | translateRoom }}</span>
                </div>
            }
        </div>
    </div>
    <div drawer-footer class="add-rooms-drawer-footer-content">
        <div>
            @if (editedLevel(); as editedLevel) {
                <mat-form-field appearance="outline" class="ca-form-field ca-form-field-s with-label">
                    <mat-label>Level of selected rooms</mat-label>
                    <mat-select
                        [disableOptionCentering]="true"
                        panelClass="ca-dropdown-panel-class"
                        [value]="editedLevel.id"
                        (selectionChange)="changeEditedLevel($event.value)"
                    >
                        @for (level of levels(); track level.id) {
                            @if (level.number === 0 && hasUpperLevels()) {
                                <mat-divider></mat-divider>
                            }
                            <mat-option [value]="level.id">{{ level.number | levelName }}</mat-option>
                            @if (level.number === 0 && hasLowerLevels()) {
                                <mat-divider></mat-divider>
                            }
                        }
                    </mat-select>
                </mat-form-field>
            }
        </div>
        <div class="flex justify-end">
            <button mat-button class="ca-button ca-button-m" (click)="drawer.close()">{{ 'CA.BUTTON.CANCEL' | translate }}</button>
            <button mat-flat-button class="ca-button ca-button-m" (click)="confirm()" [disabled]="confirmButtonDisabled()">
                {{ 'CA.BUTTON.CONFIRM' | translate }}
            </button>
        </div>
    </div>
</ca-drawer>
